__turbopack_context__.v({
  "newFolderInput": "NewFolderRow-module__mmPuaa__newFolderInput",
});
